"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Screen_exports = {};
__export(Screen_exports, {
  Screen: () => Screen
});
module.exports = __toCommonJS(Screen_exports);
var import_use_isomorphic_layout_effect = require("@vxrn/use-isomorphic-layout-effect");
var import_children = require("../headless/children");
var import_useNavigation = require("../router/useNavigation");
function Screen(param) {
  var { name, options } = param;
  var navigation = (0, import_useNavigation.useNavigation)(name);
  (0, import_use_isomorphic_layout_effect.useIsomorphicLayoutEffect)(function() {
    if (options && // React Navigation will infinitely loop in some cases if an empty object is passed to setOptions.
    // https://github.com/expo/router/issues/452
    Object.keys(options).length) {
      navigation.setOptions(options);
    }
  }, [
    navigation,
    options
  ]);
  return null;
}
Object.assign(Screen, {
  [import_children.NAVIGATOR_CONFIG]: true
});
//# sourceMappingURL=Screen.js.map
